import React, { useState, useEffect } from 'react'
import { useIntl } from 'react-intl'
import swal from 'sweetalert2'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../auth/core/Auth'
import { GetGcealLessons, GetGcealGradingSystem, AddGcealResult } from '../../../pages/code/list/core/_requests';


const API_URL_REAL = process.env.REACT_APP_API_URL

export function Gceal() {

    interface ApplicantData {
        tcKimlikNo: string;
        ad: string;
        soyad: string;
        puan: number;
        tmDogru: number;
        syDogru: number;
        tmYanlis: number;
        syYanlis: number;
        basariSirasi: number;
        adaySayisi: number;
    }

    const { logout, currentUser, setCurrentUser } = useAuth();
    const [logoutt, setLogout] = useState(false);
    const intl = useIntl();
    const navigate = useNavigate();
    const [file, setFile] = useState<File | any>(null);
    const [generalDisabled, setGeneralDisabled] = useState(false);
    const [gcealLessons, setGcealLessons]: any = useState(null);
    const [gcealGradingSystems, setGcealGradingSystems]: any = useState(null);
    const [gcealPoints, setGcealPoints]: any = useState([
        { "lessonId": 8, "gcealGradingSystemId": "" }, { "lessonId": 9, "gcealGradingSystemId": "" }, { "lessonId": 10, "gcealGradingSystemId": "" }, { "lessonId": 11, "gcealGradingSystemId": "" }, { "lessonId": 12, "gcealGradingSystemId": "" },
    ]);
    const [IsMathNoteValid, setIsMathNoteValid] = useState(false);




    useEffect(() => {
        swal.fire({
            title: intl.formatMessage({
                id: 'Swal_proces'
            }),
            text: intl.formatMessage({ id: 'Swall_wait' }),
            icon: 'info',
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false
        })

        if (currentUser?.fromCyprus == "1" && currentUser?.tryosAttended !== "1") {
            swal.close();
        } else {
            navigate('/dashboard');
            swal.close();
        }


    }, [currentUser])


    useEffect(() => {
        GetGcealLessons().then((res: any) => {
            setGcealLessons(res)

        })
        GetGcealGradingSystem().then((res: any) => {

            setGcealGradingSystems(res)
        })

    }, [])


    const updateTryosAttended = async (newValue: string) => {
        return new Promise<void>((resolve, reject) => {
            if (currentUser?.id === undefined) {
                reject("User ID is undefined.");
                return;
            }

            const updatedUser = {
                ...currentUser,
                tryosAttended: newValue
            };

            setCurrentUser(updatedUser);
            resolve();
        });
    };





    const FileSelectedHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files) {
            const fileExtension = event?.target?.files[0]?.name.split(".").pop()?.toLowerCase();

            if (fileExtension !== 'pdf') {
                swal.fire({
                    title: intl.formatMessage({
                        id: 'Error'
                    }),
                    text: intl.formatMessage({ id: 'Swal_Wrong_Format_PDF' }),
                    icon: 'error',
                    confirmButtonText: intl.formatMessage({ id: 'Okay' })
                })
                return;
            }
            setFile(event.target.files[0]);
        }
    };


    const Request = async () => {

        if (!file) {
            swal.fire({
                title: intl.formatMessage({
                    id: 'Error'
                }),
                text: intl.formatMessage({ id: 'UploadGCEALExamResult' }),
                icon: 'error',
                confirmButtonText: intl.formatMessage({ id: 'Okay' })
            })
            return;
        }

        if (gcealPoints[0].gcealGradingSystemId !== "1") {

            swal.fire({
                title: intl.formatMessage({
                    id: 'PointWarning'
                }),
                text: intl.formatMessage({ id: 'MathPointWarning' }),
                icon: 'error',
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
                showCancelButton: true,
                // confirmButtonText: intl.formatMessage({ id: 'Yes' }),
                cancelButtonText: intl.formatMessage({ id: 'Okay' }),
            })
            return;
        }

        swal.fire({
            title: intl.formatMessage({
                id: 'Swal_proces'
            }),
            text: intl.formatMessage({ id: 'Swall_wait' }),
            icon: 'info',
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false
        })

        const newGcealPoints: any = gcealPoints.filter((item: any) => item.gcealGradingSystemId !== "" && item.gcealGradingSystemId !== null && item.gcealGradingSystemId !== undefined);
        const formData = new FormData();
        formData.append('GcealFile', file);
        // formData.append('GcealPoints', gcealPoints);
        newGcealPoints?.map((item: any, i: any) => {
            formData.append(`GcealPoints[${i}][LessonId]`, `${item?.lessonId}`);
            formData.append(`GcealPoints[${i}][GcealGradingSystemId]`, `${item?.gcealGradingSystemId}`);
        })
        try {

            const res = await AddGcealResult(formData)


            if (res?.status == 200) {


                swal.close();
                swal.fire({
                    title: intl.formatMessage({
                        id: 'Success'
                    }),
                    text: intl.formatMessage({ id: 'Swal_Basarili' }),
                    icon: 'success',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    confirmButtonText: intl.formatMessage({ id: 'Okay' })
                }).then(async (result: any) => {
                    if (result?.isConfirmed) {
                        await updateTryosAttended("1")
                        navigate('/exam/survey');

                    }
                });

            }


        } catch (error: any) {
            swal.close();

            console.error(error?.message || intl.formatMessage({ id: 'Error_Massage' }));
            const message: any = error?.response && error?.response?.data && error.response?.data?.message
                ? intl.formatMessage({ id: error.response.data.message })
                : intl.formatMessage({ id: 'Error_Massage' })
            swal.fire({
                title: intl.formatMessage({
                    id: 'Error'
                }),
                // text: intl.formatMessage({ id: error.response.data.message }) || intl.formatMessage({ id: 'Error_Massage' }),
                text: message,
                icon: 'error',
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
                showCancelButton: true,
                // confirmButtonText: intl.formatMessage({ id: 'Yes' }),
                cancelButtonText: intl.formatMessage({ id: 'Okay' }),
            })
            return;
        }
    }



    const handleSelectChange = (e: any, index: any) => {


        if (index == 0 && e != 1) {

            swal.fire({
                title: intl.formatMessage({
                    id: 'PointWarning'
                }),
                text: intl.formatMessage({ id: 'MathPointWarning' }),
                icon: 'warning',
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
                showCancelButton: true,
                // confirmButtonText: intl.formatMessage({ id: 'Yes' }),
                cancelButtonText: intl.formatMessage({ id: 'Cancel' }),
            })
            return;
        }


        const newGcealPoints = [...gcealPoints];
        newGcealPoints[index].gcealGradingSystemId = e;
        setGcealPoints(newGcealPoints);
    };



    return (
        <>
            <div className="alert alert-danger mt-5 d-flex flex-column  ">
                <p>{intl.formatMessage({ id: 'GCEAL_Uyari' })}</p>
                <p>-{intl.formatMessage({ id: 'GCEAL_Uyari_1' })}</p>
                <p>-{intl.formatMessage({ id: 'GCEAL_Uyari_2' })}</p>
                <p>-{intl.formatMessage({ id: 'GCEAL_Uyari_3' })}</p>
            </div>
            <div className='row fv-row mt-7'>


                <div className='row mb-10 mt-3'>
                    <label className='col-lg-6 required col-form-label fw-bold fs-6'>
                        {intl.formatMessage({ id: 'GCEALExamResult' })} (PDF)
                    </label>
                    <div className='col-lg-8 fv-row mt-3'>
                        <input type="file" accept={".PDF"} onChange={FileSelectedHandler} />
                    </div>
                </div>
                <div className='row px-5'>
                    <div className='col-lg-6 col-12'>
                        <div className='fv-row mb-5'>
                            <label className='form-label fw-bolder text-dark fs-6'>{intl.formatMessage({ id: 'Lesson' })}</label>
                            <input
                                type='text'
                                className='form-control form-control-solid form-control-md'
                                value={intl.formatMessage({ id: 'Matematik' })}
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className='col-lg-6 col-12'>
                        <div className='fv-row mb-5'>
                            <label className='form-label fw-bolder text-dark fs-6'>{intl.formatMessage({ id: 'Note' })}</label>
                            <select
                                className='form-select form-select-solid form-select-md'
                                value={gcealPoints[0].gcealGradingSystemId}
                                onChange={(e: any) => handleSelectChange(e.target.value, 0)}
                            >
                                <option value=''>{intl.formatMessage({ id: 'SEÇİNİZ' })}</option>
                                {gcealGradingSystems?.map((myval: any) => (
                                    <option value={myval?.id} key={myval as any}>
                                        {myval?.letterGrade as any}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>
                <div className='row mt-2 px-5'>
                    <div className='col-lg-6 col-12'>
                        <div className='fv-row mb-5'>
                            <label className='form-label fw-bolder text-dark fs-6'>{intl.formatMessage({ id: 'Lesson' })}</label>
                            <input
                                type='text'
                                className='form-control form-control-solid form-control-md'
                                value={intl.formatMessage({ id: 'Türkçe' })}
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className='col-lg-6 col-12'>
                        <div className='fv-row mb-5'>
                            <label className='form-label fw-bolder text-dark fs-6'>{intl.formatMessage({ id: 'Note' })}</label>
                            <select
                                className='form-select form-select-solid form-select-md'
                                value={gcealPoints[1].gcealGradingSystemId}
                                onChange={(e: any) => handleSelectChange(e.target.value, 1)}
                            >
                                <option value=''>{intl.formatMessage({ id: 'SEÇİNİZ' })}</option>
                                {gcealGradingSystems?.map((myval: any) => (
                                    <option value={myval?.id} key={myval as any}>
                                        {myval?.letterGrade as any}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>
                <div className='row mt-2 px-5'>
                    <div className='col-lg-6 col-12'>
                        <div className='fv-row mb-5'>
                            <label className='form-label fw-bolder text-dark fs-6'>{intl.formatMessage({ id: 'Lesson' })}</label>
                            <input
                                type='text'
                                className='form-control form-control-solid form-control-md'
                                value={intl.formatMessage({ id: 'Fizik' })}
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className='col-lg-6 col-12'>
                        <div className='fv-row mb-5'>
                            <label className='form-label fw-bolder text-dark fs-6'>{intl.formatMessage({ id: 'Note' })}</label>
                            <select
                                className='form-select form-select-solid form-select-md'
                                value={gcealPoints[2].gcealGradingSystemId}
                                onChange={(e: any) => handleSelectChange(e.target.value, 2)}
                            >
                                <option value=''>{intl.formatMessage({ id: 'SEÇİNİZ' })}</option>
                                {gcealGradingSystems?.map((myval: any) => (
                                    <option value={myval?.id} key={myval as any}>
                                        {myval?.letterGrade as any}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>
                <div className='row mt-2 px-5'>
                    <div className='col-lg-6 col-12'>
                        <div className='fv-row mb-5'>
                            <label className='form-label fw-bolder text-dark fs-6'>{intl.formatMessage({ id: 'Lesson' })}</label>
                            <input
                                type='text'
                                className='form-control form-control-solid form-control-md'
                                value={intl.formatMessage({ id: 'Kimya' })}
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className='col-lg-6 col-12'>
                        <div className='fv-row mb-5'>
                            <label className='form-label fw-bolder text-dark fs-6'>{intl.formatMessage({ id: 'Note' })}</label>
                            <select
                                className='form-select form-select-solid form-select-md'
                                value={gcealPoints[3].gcealGradingSystemId}
                                onChange={(e: any) => handleSelectChange(e.target.value, 3)}
                            >
                                <option value=''>{intl.formatMessage({ id: 'SEÇİNİZ' })}</option>
                                {gcealGradingSystems?.map((myval: any) => (
                                    <option value={myval?.id} key={myval as any}>
                                        {myval?.letterGrade as any}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>
                <div className='row mt-2 px-5'>
                    <div className='col-lg-6 col-12'>
                        <div className='fv-row mb-5'>
                            <label className='form-label fw-bolder text-dark fs-6'>{intl.formatMessage({ id: 'Lesson' })}</label>
                            <input
                                type='text'
                                className='form-control form-control-solid form-control-md'
                                value={intl.formatMessage({ id: 'Biyoloji' })}
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className='col-lg-6 col-12'>
                        <div className='fv-row mb-5'>
                            <label className='form-label fw-bolder text-dark fs-6'>{intl.formatMessage({ id: 'Note' })}</label>
                            <select
                                className='form-select form-select-solid form-select-md'
                                value={gcealPoints[4].gcealGradingSystemId}
                                onChange={(e: any) => handleSelectChange(e.target.value, 4)}
                            >
                                <option value=''>{intl.formatMessage({ id: 'SEÇİNİZ' })}</option>
                                {gcealGradingSystems?.map((myval: any) => (
                                    <option value={myval?.id} key={myval as any}>
                                        {myval?.letterGrade as any}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>


                <div className='col-12 mt-5 d-flex justify-content-end gap-3'>
                    <a href='/exam/tryos'>
                        <button type='button' className='btn btn-danger' >

                            {intl.formatMessage({ id: 'Back' })}

                        </button>
                    </a>
                    <button type='button' className='btn btn-primary' onClick={Request}>

                        {intl.formatMessage({ id: 'Next' })}

                    </button>
                </div>
            </div>


        </>
    )
}
